
<div *ngIf="answer" class="image-choice" (click)="handleClick()" [ngClass]="{'image-choice--disabled': disabled, 'image-choice--selected': selected}">
    <img class="image-choice__img" [src]="'assets/images/form-choices/' + answer.keyword + '.png'" alt="">
    <span class="image-choice__label text--xs text--centered">{{ answer.text }}</span>
</div>
    